
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"vuesax/bulk/note"}},[_c('path',{attrs:{"data-name":"Vector","d":"M23.334 9.625V21c0 3.5-2.088 4.667-4.667 4.667H9.334C6.755 25.666 4.667 24.5 4.667 21V9.625c0-3.792 2.088-4.667 4.667-4.667a2.61 2.61 0 00.77 1.855 2.61 2.61 0 001.855.77h4.083a2.629 2.629 0 002.625-2.625c2.578 0 4.667.875 4.667 4.667z","fill":"#bac1cc","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M18.666 4.958a2.629 2.629 0 01-2.625 2.625h-4.083a2.625 2.625 0 010-5.25h4.083a2.629 2.629 0 012.625 2.625zM14 16.042H9.333a.881.881 0 01-.875-.875.881.881 0 01.875-.875H14a.881.881 0 01.875.875.881.881 0 01-.875.875z","fill":"#bac1cc"}}),_c('g',{attrs:{"data-name":"Group"}},[_c('path',{attrs:{"data-name":"Vector","d":"M18.666 20.708H9.333a.881.881 0 01-.875-.875.881.881 0 01.875-.875h9.333a.881.881 0 01.875.875.881.881 0 01-.875.875z","fill":"#bac1cc"}})])])])
          )
        }
      }
    